var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"asystent-360-mesh-orb",attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }